<template>
  <div>
    <div class="text-center" v-show="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-form @submit.prevent="save" v-show="!isLoading">
      <b-row>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.user"
            label-for="userSelected"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.user"
              :rules="$v.userSelected.$params"
            />
            <selectAsync
              :options="user_options"
              v-model="$v.userSelected.$model"
              :overrideLabel="false"
              :asyncFind="getUser"
              :isValid="$v.userSelected.$dirty ? !$v.userSelected.$error : null"
              label="name"
              id="code"
            >
            </selectAsync>
            <b-form-invalid-feedback id="person_id-feedback"
              >{{ $lang.error_required | replace($lang.person) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col xs="12" md="12">
          <b-form-group :label="$lang.name" label-for="name" :label-cols="12">
            <requiredComponent
              slot="label"
              :label="$lang.name"
              :rules="$v.name.$params"
            />
            <b-form-input
              id="name"
              type="text"
              v-model="$v.name.$model"
              :state="$v.name.$dirty ? !$v.name.$error : null"
              :autocomplete="$lang.name"
            ></b-form-input>
            <b-form-invalid-feedback id="name-feedback"
              >نام ضروری است</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.action"
            label-for="action"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.action"
              :rules="$v.action.$params"
            />
            <b-form-input
              id="action"
              type="text"
              v-model="$v.action.$model"
              :state="$v.action.$dirty ? !$v.action.$error : null"
              :autocomplete="$lang.action"
            ></b-form-input>
            <b-form-invalid-feedback id="action-feedback"
              >نام ضروری است</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.show_at"
            label-for="show_at"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.show_at"
              :rules="$v.show_at.$params"
            />
            <date-picker
              v-model="$v.show_at.$model"
              :state="$v.show_at.$dirty ? !$v.show_at.$error : null"
              type="datetime"
              inputReq="true"
              :clearable="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="dddd jDD jMMMM jYYYY"
              min="1900/01/02"
              :roundMinute="true"
              :class="
                $v.show_at.$dirty
                  ? $v.show_at.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback id="show_at-feedback"
              >زمان شروع ضروری است</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>

        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.description"
            label-for="address"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.description"
              :rules="$v.description.$params"
            />
            <b-form-textarea
              id="description"
              type="text"
              v-model="$v.description.$model"
              :autocomplete="$lang.description"
              :rows="this.$config.form.textareaRows"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col xs="12" md="12" v-if="showUpload">
          <button
            type="button"
            @click="fileManagerModal = !fileManagerModal"
            class="btn btn-primary"
          >
            {{ $lang.attachFile }}
          </button>
        </b-col>
        <b-col xs="12" md="12">
          <div slot="footer" class="form-group form-btn">
            <b-button type="submit" size="md" variant="success">
              {{ $lang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="cancel"
            >
              {{ $lang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
    <!-- ok-only @ok="doFilter"  -->

    <b-modal
      :title="$lang.search.columns_setting"
      variant="primary"
      hide-header
      content-class="border-primary"
      size="xl"
      v-model="fileManagerModal"
      :ok-title="$lang.submitButton"
    >
      <uploadFile
        v-if="taskId"
        :keyServies="`task`"
        :keyValue="taskId"
        :file_types="file_types"
      />
      <template v-slot:modal-footer>
        <b-button
          variant="success"
          @click="
            addExercise();
            fileManagerModal = false;
          "
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="cancel"
        >
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import uploadFile from "@/components/base/uploadFile";

export default {
  name: "task-from",
  validations: {
    userSelected: {
      required,
    },
    show_at: {
      required,
    },
    action: {
      required,
    },
    name: {
      required,
    },
    description: {
      required,
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    uploadFile,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      defult: {},
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file_types: ["image", "office", "media", "other"],
      fileManagerModal: false,
      user_options: [],
      userSelected: null,
      show_at: null,
      action: null,
      name: null,
      description: null,
      taskId: null,
    };
  },
  methods: {
    cancel() {
      this.$emit("modal-end-up", false);
    },
    getUser(query) {
      if (!query || query.length < 3) {
        this.user_options = [];
        return;
      }
      this.$httpService
        .get(
          this.$config.api_url +
            this.$config.resources.user +
            "?search_txt=" +
            query
        )
        .then((response) => {
          let user = response.data.data.result.map((x) => {
            x.name = x.person.name;
            return x;
          });
          this.user_options = user;
        })
        .catch((err) => {
          this.user_options = [];
        });
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        user_code: this.userSelected && this.userSelected.code,
        show_at: this.show_at,
        action: this.action,
        name: this.name,
        description: this.description,
      };
      this.$emit("submit", payload);
    },
    fileManager() {
      this.fileManagerModal = true;
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        if (this.item.user) {
          let user = {
            name: this.item.user.name + " " + this.item.user.family,
            code: this.item.user.code,
          };
          this.userSelected = user;
        }
        (this.show_at = this.item.show_at && this.item.show_at.gregorian),
          (this.action = this.item.action),
          (this.name = this.item.name),
          (this.description = this.item.description);
        this.taskId = this.item.id.toString();
      }
    },
  },
  watch: {
    userSelected() {},
  },
  created() {
    this.fetchData();
  },
};
</script>
